<template>
  <form @submit.prevent>
    <CModal
        :title.sync="title"
        color="info"
        :closeOnBackdrop ="false"
        :show.sync="show">
        <CRow>
          <CCol>
            <label > Coach List </label>
            <multiselect v-model="form.coach_id" placeholder="Manage Coach" :custom-label="coachName" :options="options" label="text" track-by="value"></multiselect>
             
            <!-- <b-form-select v-model="form.coach_id" :options="options"></b-form-select> -->
            </CCol> 
          </CRow>
        <template #footer>
        <CButton @click="show = false" color="danger">Cancel</CButton>
        <CButton  v-if="mode === 'edit'" type="submit" v-on:click.prevent="updateCoach(form.uuid, form.coach_id)"  variant="outline" color="info">Update</CButton>
      </template>
    </CModal>
  </form>

</template>

<script>
import axios from 'axios'
import EventBus from '@/eventBus';

import icare from '@/services/icareyouth'
import member from '@/services/member'
import group from '@/services/coachgroupyouth'

import Multiselect from 'vue-multiselect'

export default {
name: 'icaremodal',
components: {Multiselect },
  data () {
    return {
      show: false,
      title: 'Default Title',
      mode: '',
      form:{
        uuid:'',
        coach_id:[],
      },
      options:[],
    }
  },
  mounted (){
  this.load()

      EventBus.$on('PAGE_UPDATE', (data) => {
      if(data){
          this.load();
      }
    });
   },
  created () {
    var self = this;
    EventBus.$on('OPEN_MODAL_MANAGE_COACH', (params) => {
      if(params.data){
        member.getMember()
        .then(res => {
          self.show = true;
          self.title = params.title;
          self.mode = params.mode;
          self.form.id = res.data.id;
          self.form.name = res.data.name;
          self.form.coach_id = res.data.coach_id;
        }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }else{
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.form.id = "";
        self.form.name = "";
        self.form.coach_id = "";
      }
    });
    this.form.uuid = this.$route.query.Pud
    this.options = []
    member.getMember()
    .then(res => {
      console.log(res.data.member)
      for (let i=0; i <= res.data.member.length-1; i++){
        //alert
        this.options.push({text: res.data.member[i].name, value:res.data.member[i].uuid})
        console.log('test');
      }
    }).catch((er) =>{
      var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
         console.log(this.options)
    })


  },
  
  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
    },
    coachName ({ text }) {
      return `${text}`
    },
    updateCoach(id,coach_id){
      this.show = false;
      if(confirm("Do you really want to change your icare coach?")){
          var param = {
            coach_id: this.form.coach_id['value'],
          }
          console.log(id)
          console.log(this.form.coach_id['value'])
          group.updateCoach(this.$route.query.Pud, param)
          .then(res => {
            //this.load()
            EventBus.$emit('PAGE_UPDATE', true)
            var params = {title: 'Success', mode:'success', data:res.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
          }).catch ((err) => {
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
            console.log(param)
          })
        }
    },
     load(){
     group.getGroupbyID(this.$route.query.Pud)
      .then(res => {
      this.datas =res
     
      })
    },
    
  }
}
</script>



<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>